import {
  activateKeepAwakeAsync,
  deactivateKeepAwake,
  isAvailableAsync,
} from 'expo-keep-awake';
import { useEffect } from 'react';
import { Platform } from 'react-native';

const kTag = 'workshop-board';

/**
 * The display stays on while the board shows. A browser drops its wake
 * lock whenever the tab is hidden, so it is taken again each time the page
 * shows; a browser without one (plain http on the LAN) just sleeps.
 */
export function useKeepScreenAwake() {
  useEffect(() => {
    let active = true;
    const activate = () =>
      activateKeepAwakeAsync(kTag).catch(error =>
        console.error('workshop board: keep awake failed', error),
      );
    const onVisible = () => {
      if (document.visibilityState === 'visible') void activate();
    };
    void isAvailableAsync().then(available => {
      if (!active) return;
      if (!available) {
        console.warn('workshop board: the screen may sleep (no wake lock)');
        return;
      }
      void activate();
      if (Platform.OS === 'web') {
        document.addEventListener('visibilitychange', onVisible);
      }
    });
    return () => {
      active = false;
      if (Platform.OS === 'web') {
        document.removeEventListener('visibilitychange', onVisible);
      }
      deactivateKeepAwake(kTag).catch(() => undefined);
    };
  }, []);
}
